import * as React from "react";
import { hot } from "react-hot-loader";
import { CSSTransition } from 'react-transition-group';
import DataProviderSharePoint from '../../dataproviders/DataProvidersSharePoint';
import { ICategorie } from '../../interfaces/ICategorie';
import EnmUtils from '../../utils/EnmUtils';
import CustomLoader from '../CustomLoader/CustomLoader';
import CandidaturesTable from './CandidaturesTable/CandidaturesTable';
import { ICandidaturesState } from './ICandidaturesState';
import PromotionsList from './PromotionsList/PromotionsList';
declare var formulaireCandidature: any;


class Candidatures extends React.Component<{}, ICandidaturesState> {

  private _dataProvider = new DataProviderSharePoint();

  constructor(props: any) {
    super(props);

    this.state = {
      IsReady: false,
      ConnectedLogin: EnmUtils.getLoginConnectedUser(),
      AllCandidaturesResp: {
        Message: '',
        OK: false,
        List: []
      },
      AllPromotionsOpenedResp: {
        Message: '',
        OK: false,
        List: []
      },
      EtatCandidatureList: [],
      EtatDepotCandidatureList: [],
      CategorieList: this.constructCategorieList()
    }
  }

  public componentDidMount() {
    Promise.all([this.getEtatDepotCandidature(), this.getEtatCandidature()]).then(values => {
      this.getAllPromotionsOpened();
      this.getAllCandidatures();
    });
  }

  public render() {

    return (
      <div id="candidatures">
        <CSSTransition
          classNames="loader"
          in={!this.state.IsReady || !this.state.AllPromotionsOpenedResp.OK || (!this.state.AllCandidaturesResp.OK && this.state.AllCandidaturesResp.Message === '')}
          timeout={300}
          unmountOnExit={true}
        >
          <CustomLoader />
        </CSSTransition>


        <CSSTransition
          classNames="fadein"
          in={this.state.IsReady && this.state.AllPromotionsOpenedResp.OK && (this.state.AllCandidaturesResp.OK || this.state.AllCandidaturesResp.Message !== '')}
          timeout={300}
          unmountOnExit={true}
        >
          <div className="col-12 col-lg-10 offset-lg-1">
            <CandidaturesTable candidaturesList={this.state.AllCandidaturesResp.List}
              EtatDepotCandidatureList={this.state.EtatDepotCandidatureList}
              categorieList={this.state.CategorieList}
              ConnectedLogin={this.state.ConnectedLogin} />

            <PromotionsList promotionsList={this.state.AllPromotionsOpenedResp.List}
              candidaturesList={this.state.AllCandidaturesResp.List}
              EtatDepotCandidatureList={this.state.EtatDepotCandidatureList}
              EtatCandidatureList={this.state.EtatCandidatureList}
              ConnectedLogin={this.state.ConnectedLogin} />
          </div >
        </CSSTransition>
      </div >
    );
  }

  private getAllPromotionsOpened(): void {
    this._dataProvider.getPromotionOpened().then(resp => {
      this.setState({ IsReady: true, AllPromotionsOpenedResp: resp });
    });
  }

  private getAllCandidatures(): void {
    this._dataProvider.getCandidaturesByLogin(this.state.ConnectedLogin).then(resp => {
      this.setState({ IsReady: true, AllCandidaturesResp: resp });
    });
  }

  private getEtatCandidature(): Promise<void> {

    return this._dataProvider.getInput("EtatCandidature").then(resp => {
      this.setState({ EtatCandidatureList: resp.List[0].Choices.split(';') });
    });
  }

  private getEtatDepotCandidature(): Promise<void> {

    return this._dataProvider.getInput("EtatDepotCandidature").then(resp => {
      this.setState({ EtatDepotCandidatureList: resp.List[0].Choices.split(';') });
    });
  }

  private constructCategorieList(): ICategorie[] {
    const categorieList: ICategorie[] = [];

    Object.keys(formulaireCandidature).map((key) => {
      const categorie: ICategorie = { categorieItems: [], categorieName: "" };
      categorie.categorieName = key;
      categorie.categorieItems = formulaireCandidature[key];
      categorieList.push(categorie);
    });

    return categorieList;
  }
}

export default hot(module)(Candidatures);
